import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';

interface IServerResponse {
  status: any;
  message: string;
  result: any;
  count: number;
  name: any;
  // totalPages: number;
}

const API_URL = environment.API_URL + '/admin';

@Injectable()
export class BadgeService {
  admin_data: any = JSON.parse(localStorage.getItem('user'));
  constructor(private http: HttpClient, private https: Http) { }

  // ➕ Create Badge
  createBadge(formData: any): Observable<IServerResponse> {
    return this.https.post(API_URL + '/badge', formData).pipe(
      map(res => res.json())
    );
  }

  // 📋 Get All Badges
  getBadges(): Observable<IServerResponse> {
    return this.https.get(API_URL + '/allbadge').pipe(
      map(res => res.json())
    );
  }

  // 🔎 Get Badge by ID
  getBadgeById(id: any): Observable<IServerResponse> {
    return this.https.get(API_URL + '/badgebyid/' + id).pipe(
      map(res => res.json())
    );
  }

  // ✏️ Update Badge
  updateBadge(formData: any): Observable<IServerResponse> {
    return this.https.put(API_URL + '/badge', formData).pipe(
      map(res => res.json())
    );
  }

  // ❌ Delete Badge
  deleteBadge(id: any): Observable<IServerResponse> {
    return this.https.delete(API_URL + '/badge/' + id).pipe(
      map(res => res.json())
    );
  }

  // 🔎 Filter Badges (search)
  getBadgesWithFilter(filterValue: string): Observable<IServerResponse> {
    return this.https.get(API_URL + `/badgewithfilter/${filterValue}`).pipe(
      map(res => res.json())
    );
  }

  // 🔎 Filter + Pagination
  getBadgesWithFilterAndPage(filterValue: string, page: number): Observable<IServerResponse> {
    return this.https.get(API_URL + `/badgefilterandpage/${page}/${filterValue}`).pipe(
      map(res => res.json())
    );
  }

  // 📄 Pagination (all badges, not filtered)
  getBadgesWithPage(page: number) {
    return this.https.get(API_URL + `/badge/${page}`).pipe(
      map(res => res.json())
    );
  }

  //Badge Package
  // ➕ Create Badge
  createBadgePackage(formData: any): Observable<IServerResponse> {
    return this.https.post(API_URL + '/badgepackage', formData).pipe(
      map(res => res.json())
    );
  }

  // 📋 Get All Badges
  getBadgePackages(): Observable<IServerResponse> {
    return this.https.get(API_URL + '/allbadgepackage').pipe(
      map(res => res.json())
    );
  }

  // 🔎 Get Badge by ID
  getBadgePackageById(id: any): Observable<IServerResponse> {
    return this.https.get(API_URL + '/badgepackagebyid/' + id).pipe(
      map(res => res.json())
    );
  }

  // ✏️ Update Badge
  updateBadgePackage(formData: any): Observable<IServerResponse> {
    return this.https.put(API_URL + '/badgepackage', formData).pipe(
      map(res => res.json())
    );
  }

  // ❌ Delete Badge
  deleteBadgePackage(id: any): Observable<IServerResponse> {
    return this.https.delete(API_URL + '/badgepackage/' + id).pipe(
      map(res => res.json())
    );
  }

  getBadgeUserList(query: any): Observable<IServerResponse> {
    let params = new URLSearchParams();
    if (query.badge_id) params.set('badge_id', query.badge_id);
    if (query.page) params.set('page', String(query.page));
    if (query.limit) params.set('limit', String(query.limit));
    if (query.search) params.set('search', query.search);
    
    return this.https.get(API_URL + `/listbadgeusers?${params.toString()}`).pipe(
      map(res => res.json())
    );
  }

  // 🔎 Filter Badges (search)
  getBadgePackagesWithFilter(filterValue: string, type: string): Observable<IServerResponse> {
    return this.https.get(API_URL + `/badgepackagewithfilter/${filterValue}/${type}`).pipe(
      map(res => res.json())
    );
  }

  // 🔎 Filter + Pagination
  getBadgePackagesWithFilterAndPage(filterValue: string, page: number, type: string): Observable<IServerResponse> {
    return this.https.get(API_URL + `/badgepackagefilterandpage/${page}/${filterValue}/${type}`).pipe(
      map(res => res.json())
    );
  }

  // 📄 Pagination (all badges, not filtered)
  getBadgePackagesWithPage(page: number, type: string): Observable<IServerResponse> {
    return this.https.get(API_URL + `/badgepackage/${page}/${type}`).pipe(
      map(res => res.json())
    );
  }

  /* save badge image */
  uploadbagdeimage(formData: any) {
    return this.https.post(API_URL + '/upbadgeimage', formData).pipe(
      map(res => {
        return res.json();
      }));
  }
  updateBadgeOrder(payload: any) {
    payload.admin_id = this.admin_data._id;
    return this.https.post(API_URL + '/updatebadgeorder', payload).pipe(
      map(res => res.json())
    );
  }

  getUserBadges(id: string) {
    return this.https.get(API_URL + `/getuserbadges/${id}`).pipe(
      map(res => res.json())
    );
  }
  getBadgesByUserid(id: string, type: string) {
    return this.https.get(API_URL + `/getbadgesbyuserid/${id}/${type}`).pipe(
      map(res => res.json())
    );
  }
  // Get all badges (Badge model)
  // getBadges(): Observable<any> {
  //   return this.http.get(this.base + '/admin/badges/list'); // implement backend
  // }

  // Get badge packages for badgeId + type (normal/onetoone)
  // getBadgePackages(badgeId: string, type: string): Observable<any> {
  //   return this.https.post(API_URL + '/admin/getbadgepackages', { badgeId: badgeId, type: type });
  // }

  // Add badge to user (type normal or onetoone)
  addBadgeToUser(payload: any) {
    return this.https.post(API_URL + '/addbadgetouser', payload).pipe(
      map(res => res.json())
    );
  }

  // Remove a user badge: pass userBadgeId (the subdocument id in user.badges.normal/onetoone) and type
  removeBadgeFromUser(payload: any) {
    return this.https.post(API_URL + '/removebadge', payload).pipe(
      map(res => res.json())
    );
  }
  getUserProfileByContact(userId: string, phoneNo: string, countryCode: string) {
    return this.https.get(API_URL + `/getUserProfile/${userId}/${phoneNo}/${countryCode}`).pipe(
      map(res => res.json())
    );

  }

  userChatRestriction(payload: any) {
    return this.https.put(API_URL + `/userChatRestriction`, payload).pipe(
      map(res => res.json())
    );

  }
  createAdminUser(payload: any) {
    return this.https.post(API_URL + `/adminuser`, payload).pipe(
      map(res => res.json())
    );

  }
  getAllAdminUsers(page: any) {
    return this.https.get(API_URL + `/adminuser/${page}`,).pipe(
      map(res => res.json())
    );

  }
  updateAdminUser(payload: any) {
    return this.https.put(API_URL + `/adminuser`, payload).pipe(
      map(res => res.json())
    );

  }

  deleteAdminUser(id: any) {
    return this.https.delete(API_URL + `/adminuser/${id}`).pipe(
      map(res => res.json())
    );

  }

  searchAdminUsers(query: any) {
return this.https.get(API_URL + `/searchadminuser`, { params: { q: query } }).pipe(
  map(res => res.json())
);


  }
}
